<template>
  <el-table
      :data="payments"
      style="width: 100%">
      <div slot="empty">
        <span>{{$t('payments.noPayments')}}</span><br>
        <el-button size="small" @click="$emit('addPayment')" :disabled="status.code=='PAID' || !$can('manage','Invoice')">{{$t('payments.add')}} <i class="el-icon-circle-plus-outline"/></el-button>
      </div>
      <el-table-column type="expand">
        <template slot-scope="props">
          <PaymentInvoiceCard :payment="props.row" :currency="currency"></PaymentInvoiceCard>
        </template>
      </el-table-column>
      <el-table-column
        prop="date"
        :label="$t('common.date')">
        <template slot-scope="scope">
          <span v-if="scope.row.date">{{ _moment(scope.row.date,'l') }}</span>
          <span v-else>{{$t('NA')}}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="invoice_payment.amount"
        :label="$t('payments.totalAmount')">
        <template slot-scope="scope">
          <span>{{ $n(scope.row.amount,'currency', currency) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="invoice_payment.amount"
        :label="$t('payments.amountApplied')">
        <template slot-scope="scope">
          <span>{{ $n(scope.row.amountApplied,'currency',currency) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="payment_type.code"
        :label="$t('payments.paymentMethod')">
        <template slot-scope="scope">
          <span>{{$t('invoices.'+scope.row.type.code)}}</span>
        </template>
      </el-table-column>
      <el-table-column
      align="right"
      width="150">

        <template slot-scope="scope">
          <!-- <el-button
            size="mini"
            circle
            :disabled="!$can('manage','Invoice')"
            @click="handleEdit(scope.$index,scope.row)"><i class="mdi mdi-lead-pencil" style="font-size:15px;"></i></el-button> -->
          <el-button
            size="mini"
            circle
            type="danger"
            :disabled="!$can('manage','Invoice')"
            @click="handleDelete(scope.$index,scope.row)"><i class="mdi mdi-delete" style="font-size:15px;"></i></el-button>
        </template>
      </el-table-column>
    </el-table>
</template>
<script>
import moment from 'moment-timezone'
import PaymentAPI from '@/services/API/payment.js'
import PaymentInvoiceCard from '@/components/invoice/invoice-payment-card-v2.vue'

export default {
  name: 'PaymentsTable',
	props: {
    payments : Array,
    status : Object,
    currency : {
      type : String,
      default : 'CAD'
    }
	},
  data() {
    return {

    };
  },components: {
    PaymentInvoiceCard
  },
  watch : {

  },
	methods: {
    _moment(datetime, format='LL'){
      return moment(datetime).format(format);
    },
    handleDelete(index,paymentToEdit){
      this.$emit('deleted',{index, payment:paymentToEdit})
    },
    handleEdit(index,paymentToEdit){
      this.$emit('edit',{index, payment:paymentToEdit})
    }
	},
	computed: {

	}
}
</script>
<style lang="scss" scoped>

</style>
